import { Baseurl, ajaxPost } from '@/api/api/api'
import { Message } from 'element-ui'
import * as XLSX from 'xlsx';

// item 渠道信息
export function printInfo(item) {
	// console.log(item)

	let API = ''
	// type: 1.三态 2.云途 3.燕文 4.第三方
	switch (item.type) {
		case 1:
			API = Baseurl + 'sanTaiController/GetSanTaiSingleLabel'
			break
		case 2:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 3:
			API = Baseurl + 'yanWenController/getYanWenLabel'
			break
		case 4:
			API = Baseurl + 'logisticsController/getSanOrderChannelById'
			break
		case 6:
			API = Baseurl + 'dsfController/getLabel'
			break
		case 7:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 8:
			API = Baseurl + 'taiJiaController/getOrderPrintLabel'
			break
		case 9:
			API = Baseurl + 'baDaTongController/freemarkerPrint'
			break
		case 10:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 11:
			API = Baseurl + 'dsfController/getLabel'
			break
		case 14:
			API = Baseurl + 'imlShippingMethodController/getImlLabal'
			break
		default:
			console.error(item.channelName, '请传入正确的渠道！')
	}
	const UserInfo = JSON.parse(localStorage.getItem('role'))
	const paramsData = {
		companyId: UserInfo.company_id,
		applyFromStatus: item.applyFromStatus,
		type: item.type,
	}
	if ([1, 2, 3, 7, 10, 14].includes(item.type)) {
		paramsData.conveyNumber = item.conveyNumber
	} else if ([6, 9, 11].includes(item.type)) {
		paramsData.orderChannelId = item.orderChannelId
	} else if ([8].includes(item.type)) {
		paramsData.conveyNumber = item.trackNumber
	} else {
		paramsData.id = item.id
	}
	return new Promise((resolve, reject) => {
		ajaxPost(API, paramsData)
			.then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					window.open(data)
					resolve()
				} else {
					Message.error(data)
					reject()
				}
			})
			.catch((err) => {
				reject()
				if (err.message === '取消请求') {
					Message.warning('正在处理，请勿连续操作！')
				} else {
					Message.error('操作出错！')
				}
			})
	})
}

export function getWaybillUrl(item) {
	// console.log(item)

	let API = ''
	// type: 1.三态 2.云途 3.燕文 4.第三方
	switch (item.type) {
		case 1:
			API = Baseurl + 'sanTaiController/GetSanTaiSingleLabel'
			break
		case 2:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 3:
			API = Baseurl + 'yanWenController/getYanWenLabel'
			break
		case 4:
			API = Baseurl + 'logisticsController/getSanOrderChannelById'
			break
		case 6:
			API = Baseurl + 'dsfController/getLabel'
			break
		case 7:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 8:
			API = Baseurl + 'taiJiaController/getOrderPrintLabel'
			break
		case 9:
			API = Baseurl + 'baDaTongController/freemarkerPrint'
			break
		case 10:
			API = Baseurl + 'yunTuController/labelPrint'
			break
		case 11:
			API = Baseurl + 'dsfController/getLabel'
			break
		case 14:
			API = Baseurl + 'imlShippingMethodController/getImlLabal'
			break
		default:
			console.error(item.channelName, '请传入正确的渠道！')
	}
	const UserInfo = JSON.parse(localStorage.getItem('role'))
	const paramsData = {
		companyId: UserInfo.company_id,
		applyFromStatus: item.applyFromStatus,
		type: item.type,
	}
	if ([1, 2, 3, 7, 10, 14].includes(item.type)) {
		paramsData.conveyNumber = item.conveyNumber
	} else if ([6, 9, 11].includes(item.type)) {
		paramsData.orderChannelId = item.orderChannelId
	} else if ([8].includes(item.type)) {
		paramsData.conveyNumber = item.trackNumber
	} else {
		paramsData.id = item.id
	}
	return new Promise((resolve, reject) => {
		ajaxPost(API, paramsData)
			.then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					resolve(data)
				} else {
					reject(data)
				}
			})
			.catch((err) => {
				reject()
				if (err.message === '取消请求') {
					Message.warning('正在处理，请勿连续操作！')
				} else {
					Message.error('操作出错！')
				}
			})
	})
}

export function increaseNum(item) {
	return new Promise((resolve, reject) => {
		let API = Baseurl + '/logisticsController/updateOrderChannelPrinftCount'
		const paramsData = { id: item.id }

		ajaxPost(API, paramsData)
			.then((res) => {
				const { code } = res.data
				if (code === 200) {
					resolve()
				} else {
					reject()
				}
			})
			.catch(() => {
				reject()
			})
	})
}

export function copyText(text) {
	if (navigator.clipboard && navigator.clipboard.writeText) {
		return navigator.clipboard.writeText(text);
	} else {
		// fallback
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'absolute';
		textarea.style.left = '-9999px';
		document.body.appendChild(textarea);
		textarea.select();
		const success = document.execCommand('copy');
		document.body.removeChild(textarea);
		return new Promise((resolve, reject) => {
			if (success) {
				resolve();
			} else {
				reject(new Error('复制失败'));
			}
		});
	}
}

/**
 * 精确保留小数位数
 * @param {number|string} value - 要处理的数字
 * @param {number} decimals - 要保留的小数位数
 * @param {boolean} [returnString=false] - 是否返回字符串（否则返回 number）
 * @returns {number|string}
 */
export function toFixedSafe(value, decimals = 2, returnString = false) {
	if (isNaN(value) || value === null || value === undefined) return returnString ? '0.00' : 0;

	const factor = Math.pow(10, decimals);
	const result = Math.round(Number(value) * factor) / factor;

	// 使用 toFixed 避免科学记数法、补 0
	return returnString ? result.toFixed(decimals) : Number(result.toFixed(decimals));
}

// 调退出登录接口
export function loginOut(){
	if(JSON.parse(localStorage.getItem("data"))){
		const data = JSON.parse(localStorage.getItem("data"));
		try {
			const API = Baseurl + 'userControllers/logout?telephone=' + data.data.user.telephone;
			ajaxPost(API).then(res => {
				const { code } = res.data
			})
		} catch (error) {
		}
	}
}

/**
 * 递归获取表头深度
 */
function getHeaderDepth(columns) {
    let maxDepth = 1;
    columns.forEach(col => {
        if (col.children && col.children.length) {
            maxDepth = Math.max(maxDepth, 1 + getHeaderDepth(col.children));
        }
    });
    return maxDepth;
}

/**
 * 统计叶子节点数量（用来合并单元格）
 */
function countLeafColumns(columns) {
    let count = 0;
    columns.forEach(col => {
        if (col.children && col.children.length) {
            count += countLeafColumns(col.children);
        } else {
            count += 1;
        }
    });
    return count;
}

/**
 * 递归构建表头 AOA 和 merges
 */
function buildHeader(columns, rowIndex = 0, startCol = 0, aoa = [], merges = [], maxDepth = 1) {
    aoa[rowIndex] = aoa[rowIndex] || [];
    let colIndex = startCol;

    columns.forEach(col => {
        const children = col.children || [];
        const cell = col.label;

        if (children.length) {
            const childColCount = countLeafColumns(children);
            aoa[rowIndex][colIndex] = cell;
            merges.push({
                s: { r: rowIndex, c: colIndex },
                e: { r: rowIndex, c: colIndex + childColCount - 1 }
            });
            buildHeader(children, rowIndex + 1, colIndex, aoa, merges, maxDepth);
            colIndex += childColCount;
        } else {
            aoa[rowIndex][colIndex] = cell;
            // 跨行合并到最底层
            if (rowIndex < maxDepth - 1) {
                merges.push({
                    s: { r: rowIndex, c: colIndex },
                    e: { r: maxDepth - 1, c: colIndex }
                });
            }
            colIndex += 1;
        }
    });

    return { aoa, merges };
}

/**
 * 填充数据行
 */
function fillRow(columns, item, row) {
    columns.forEach(col => {
        const children = col.children || [];
        if (children.length) {
            const subItem = item[col.key] || {};
            fillRow(children, subItem, row);
        } else {
            row.push(item[col.key] !== undefined ? item[col.key] : '');
        }
    });
}

/**
 * 给单元格添加样式：边框+居中
 */
function styleSheet(ws) {
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellAddress]) continue;
            ws[cellAddress].s = {
                alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };
        }
    }
}

/**
 * 导出 Excel
 */
export function exportExcel(columns, data, fileName = 'export.xlsx') {
    const maxDepth = getHeaderDepth(columns);
    const { aoa, merges } = buildHeader(columns, 0, 0, Array.from({ length: maxDepth }, () => []), [], maxDepth);

    data.forEach(item => {
        const row = [];
        fillRow(columns, item, row);
        aoa.push(row);
    });

    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws['!merges'] = merges;

    styleSheet(ws); // 加边框居中

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName, { bookType: 'xlsx', cellStyles: true });
}

